import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithStreams,
} from 'widgets/WidgetRegistry';
import { WidgetSharedStateSection } from 'widgets/store/shared/WidgetsSharedState';
import StrategyParameters from './StrategyParameters';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { strategyParametersDescription } from './description/strategyParametesDescription';
import { strategyParametersStreamConfigs } from 'widgets/strategyParams/store/stream/stream-config';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { StrategyParametersConfigurationState } from 'widgets/strategyParams/store/configuration/StrategyParametersConfigurationState';
import { AppMode } from 'app/store/general/AppMode';

export const strategyParametersWidgetStrategy: WidgetStrategyWithConfig<StrategyParametersConfigurationState> &
    WidgetStrategyWithStreams = {
    title: 'Instinet Algo Parameters',
    supportedHosts: ['layout'],
    reactComponentType: StrategyParameters,
    sharedStateSections: [WidgetSharedStateSection.ALGORITHM_PARAMETERS],
    categories: [
        {
            appModes: [AppMode.STANDALONE],
            categories: [WidgetCategory.MULTIPLE_STOCK],
        },
        {
            appModes: [AppMode.EMBEDDED_DASHBOARD],
            categories: [WidgetCategory.PORTFOLIO],
        },
    ],
    description: strategyParametersDescription,
    streamConfigs: strategyParametersStreamConfigs,
    initialConfigState: {},
    portfolioSelectionRequirements:
        PortfolioSelectionRequirements.AtLeastOneOrder,
};
